import React from 'react';
import {useCallback} from 'react';

const SheetsRadioGroup = ({options, setSelectedSheet, selectedSheet}) => {
    const selectSheet = useCallback(
        (val) => (
            e,
        ) => {
            setSelectedSheet(val);
            return;
        },
        [setSelectedSheet],
    );

    return (
        <div className="sheet-btn-container">
            {options &&
        options.length &&
        options.map((value) => {
            return (
                <button
                    onClick={selectSheet(value.sheetId)}
                    key={value.sheetId}
                    className={value.sheetId === selectedSheet ? 'button-dash__selected' : 'button-dash__unselected'}
                >
                    {`${value.name}`}
                </button>
            );
        })}
        </div>
    );
};

export default SheetsRadioGroup;
